import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    iconReplay: {
        color: theme.palette.color.black
    },
    gridReplay: {
        textAlign: 'left'
    },
    card: {
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        marginTop: 20
    },
    root: {
        marginLeft: 10,
        marginRight: 10,
    }
}))
